/* eslint-disable import/prefer-default-export */
import { Theme } from 'features/ui/types'
import styled from 'styled-components'
import { rightToLeftStyles } from 'utils/rtlTextUtil'

interface VocTextProps {
  isDisplayTextRtl?: boolean
  mode: Theme
}

export const VocText = styled.p<VocTextProps>`
  ${({ isDisplayTextRtl }) => isDisplayTextRtl && rightToLeftStyles};

  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 10px 8px 10px 0;
`
